import { render, staticRenderFns } from "./CustomerVaultView.vue?vue&type=template&id=0830c3da&scoped=true&"
import script from "./CustomerVaultView.vue?vue&type=script&lang=js&"
export * from "./CustomerVaultView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerVaultView.vue?vue&type=style&index=0&id=0830c3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0830c3da",
  null
  
)

export default component.exports